module.exports = __webpack_public_path__ + "media/app/fonts/catamaran-v4-latin-regular-71a321c5753b1ecaab6bf080e59fff0f.eot";